// src/pages/men-wigs/men-wigs.component.jsx
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { addItem } from '../../redux/cart/cart.actions';
import { createAppointment } from '../../redux/appointment/appointment.actions';
import { firestore, collection, getDocs } from '../../firebase/firebase.utils';
import './men-wigs.styles.scss';







const MenWigs = ({ addItem, createAppointment }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Booking Form State
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [bookingData, setBookingData] = useState({
    name: '',
    phone: '',
    address: '',
    city: 'Rawalpindi',
    date: '',
    time: '',
    service: 'hair-unit',
    message: ''
  });
  const [bookingSuccess, setBookingSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const productsRef = collection(firestore, 'products');
        const querySnapshot = await getDocs(productsRef);
        
        const menWigs = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (data.category === 'men-wigs') {
            menWigs.push({ id: doc.id, ...data });
          }
        });
        
        setProducts(menWigs);
        setLoading(false);
      } catch (error) {
        console.error('Error loading products:', error);
        setLoading(false);
      }
    };
    
    loadProducts();
  }, []);

  const handleAddToCart = (product) => {
    addItem({
      id: product.id,
      name: product.title,
      price: parseInt(product.price?.replace(/,/g, '')) || 0,
      imageUrl: product.image || '',
      description: product.description
    });
    alert(`${product.title} added to cart!`);
  };

  // Booking Form Handlers
  const handleBookingChange = (e) => {
    const { name, value } = e.target;
    setBookingData(prev => ({ ...prev, [name]: value }));
  };

  // Get formatted appointment message for WhatsApp
  const getAppointmentMessage = (data) => {
    const serviceLabels = {
      'hair-unit': 'Hair Unit / Patch',
      'hair-transplant': 'Hair Transplant',
      'consultation': 'Free Consultation'
    };

    return `🦁 CRISPY HAIR SOLUTION - APPOINTMENT BOOKING
    ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
    📋 Appointment Details
    ─────────────────────────────────
    👤 Name: ${data.name}
    📱 Phone: ${data.phone}
    📍 Address: ${data.address}
    🏙️ City: ${data.city}
    📅 Date: ${data.date || 'Not specified'}
    ⏰ Time: ${data.time || 'Not specified'}
    🏥 Service: ${serviceLabels[data.service] || data.service}
    📝 Message: ${data.message || 'No additional message'}
    ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
    📌 Appointment ID: APP-${Date.now().toString().slice(-6)}
    📅 Booked on: ${new Date().toLocaleString()}
    ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
    Please confirm this appointment.`;
  };

  // Send WhatsApp Message
  const sendWhatsAppMessage = (data) => {
    const message = getAppointmentMessage(data);
    const whatsappLink = "https://wa.me/923224314712";
    window.open(`${whatsappLink}?text=${encodeURIComponent(message)}`, '_blank');
  };

  // Save to Firebase and Send WhatsApp
  const handleBookingSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Prepare appointment data
    const appointmentData = {
      ...bookingData,
      bookingDate: new Date().toISOString(),
      status: 'pending',
      source: 'men-wigs-page'
    };

    // Save to Firebase
    const result = await createAppointment(appointmentData);

    if (result.success) {
      // Send WhatsApp message
      sendWhatsAppMessage(bookingData);
      
      setBookingSuccess(true);
      setIsSubmitting(false);
      
      setTimeout(() => {
        setBookingSuccess(false);
        setShowBookingForm(false);
        setBookingData({
          name: '',
          phone: '',
          address: '',
          city: 'Rawalpindi',
          date: '',
          time: '',
          service: 'hair-unit',
          message: ''
        });
      }, 4000);
    } else {
      alert('Error saving appointment: ' + result.error);
      setIsSubmitting(false);
    }
  };

  // Direct WhatsApp Booking (without saving to Firebase)
  const handleDirectWhatsApp = () => {
    if (!bookingData.name || !bookingData.phone) {
      alert('Please fill in Name and Phone fields first');
      return;
    }
    sendWhatsAppMessage(bookingData);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loader"></div>
        <p>Loading products...</p>
      </div>
    );
  }

  return (
    <div className="men-wigs-page">
      <div className="page-header">
        <h1>👔 Men's Wigs Collection</h1>
        <p>Premium quality men's wigs crafted from 100% human hair</p>
        <button 
          className="book-appointment-btn"
          onClick={() => setShowBookingForm(true)}
        >
          📅 Book Appointment
        </button>
      </div>

      {/* Booking Form Modal */}
      {showBookingForm && (
        <div className="booking-modal" onClick={() => {
          if (!isSubmitting) setShowBookingForm(false);
        }}>
          <div className="booking-modal-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="close-modal" 
              onClick={() => {
                if (!isSubmitting) setShowBookingForm(false);
              }}
              disabled={isSubmitting}
            >
              ×
            </button>
            <h2>📅 Book Appointment</h2>
            <p>Fill in your details and we'll contact you</p>

            {bookingSuccess ? (
              <div className="booking-success">
                <span>✅</span>
                <h3>Appointment Saved!</h3>
                <p>We have received your request and will contact you shortly.</p>
                <p className="whatsapp-note">💬 A message has been sent to WhatsApp</p>
              </div>
            ) : (
              <form onSubmit={handleBookingSubmit}>
                <div className="form-group">
                  <label>👤 Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your full name"
                    value={bookingData.name}
                    onChange={handleBookingChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>

                <div className="form-group">
                  <label>📱 Phone Number *</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Enter your phone number"
                    value={bookingData.phone}
                    onChange={handleBookingChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>

                <div className="form-group">
                  <label>📍 Address *</label>
                  <input
                    type="text"
                    name="address"
                    placeholder="Enter your full address"
                    value={bookingData.address}
                    onChange={handleBookingChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>

                <div className="form-group">
                  <label>🏙️ Select City *</label>
                  <select
                    name="city"
                    value={bookingData.city}
                    onChange={handleBookingChange}
                    required
                    disabled={isSubmitting}
                  >
                    <option value="Rawalpindi">Rawalpindi</option>
                    <option value="Islamabad">Islamabad</option>
                    <option value="Lahore">Lahore</option>
                    <option value="Karachi">Karachi</option>
                    <option value="Multan">Multan</option>
                    <option value="Faisalabad">Faisalabad</option>
                    <option value="Peshawar">Peshawar</option>
                    <option value="Quetta">Quetta</option>
                    <option value="Other">Other City</option>
                  </select>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>📅 Appointment Date *</label>
                    <input
                      type="date"
                      name="date"
                      value={bookingData.date}
                      onChange={handleBookingChange}
                      min={new Date().toISOString().split('T')[0]}
                      required
                      disabled={isSubmitting}
                    />
                  </div>

                  <div className="form-group">
                    <label>⏰ Preferred Time *</label>
                    <select
                      name="time"
                      value={bookingData.time}
                      onChange={handleBookingChange}
                      required
                      disabled={isSubmitting}
                    >
                      <option value="">Select time</option>
                      <option value="09:00 AM">09:00 AM</option>
                      <option value="10:00 AM">10:00 AM</option>
                      <option value="11:00 AM">11:00 AM</option>
                      <option value="12:00 PM">12:00 PM</option>
                      <option value="01:00 PM">01:00 PM</option>
                      <option value="02:00 PM">02:00 PM</option>
                      <option value="03:00 PM">03:00 PM</option>
                      <option value="04:00 PM">04:00 PM</option>
                      <option value="05:00 PM">05:00 PM</option>
                      <option value="06:00 PM">06:00 PM</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>🏥 Service Type *</label>
                  <select
                    name="service"
                    value={bookingData.service}
                    onChange={handleBookingChange}
                    required
                    disabled={isSubmitting}
                  >
                    <option value="hair-unit">Hair Unit / Patch</option>
                    <option value="hair-transplant">Hair Transplant</option>
                    <option value="consultation">Free Consultation</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>📝 Additional Message</label>
                  <textarea
                    name="message"
                    placeholder="Any special requests or questions..."
                    value={bookingData.message}
                    onChange={handleBookingChange}
                    rows="3"
                    disabled={isSubmitting}
                  />
                </div>

                <div className="form-buttons">
                  <button 
                    type="submit" 
                    className="submit-booking-btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Saving...' : '💾 Save & Send WhatsApp'}
                  </button>
                  
                  <button 
                    type="button" 
                    className="whatsapp-only-btn"
                    onClick={handleDirectWhatsApp}
                    disabled={isSubmitting || !bookingData.name || !bookingData.phone}
                  >
                    💬 Send WhatsApp Only
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {/* Products Grid */}
      {products.length === 0 ? (
        <div className="no-products">
          <p>No products found. Admin please add products.</p>
        </div>
      ) : (
        <div className="products-grid">
          {products.map((product) => (
            <div className="product-card" key={product.id}>
              <div className="product-image">
                <img 
                  src={product.image || '/images/default.jpg'} 
                  alt={product.title}
                  onError={(e) => {
                    e.target.src = '/images/default.jpg';
                  }}
                />
                {product.isNew && <span className="new-badge">NEW</span>}
              </div>
              <div className="product-info">
                <h3>{product.title}</h3>
                <p className="product-description">{product.description}</p>
                <div className="product-footer">
                  <span className="product-price">{product.price}</span>
                  <button 
                    className="add-to-cart-btn"
                    onClick={() => handleAddToCart(product)}
                  >
                    🛒 Add to Cart
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  addItem: item => dispatch(addItem(item)),
  createAppointment: (data) => dispatch(createAppointment(data))
});

export default connect(null, mapDispatchToProps)(MenWigs);